module.exports = __webpack_public_path__ + "Roboto-BoldItalic.woff2?94008e69aaf05da75c0bbf8f8bb0db41";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/BoldItalic/Roboto-BoldItalic.woff2?v=2.137
// module id = 191
// module chunks = 7